module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1271.e146f6e2.png";